import { ArrowLeft, Shield, User, Clock, FileCheck, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
          <h1 className="text-4xl font-bold">Datenschutzerklärung</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12 space-y-10">
          
          {/* Intro */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <Shield className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">Datenschutz</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir behandeln Ihre personenbezogenen 
              Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO) sowie 
              dieser Datenschutzerklärung.
            </p>
          </section>

          {/* Responsible */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center">
                <User className="w-5 h-5 text-slate-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Verantwortlicher für die Datenverarbeitung</h2>
            </div>
            <div className="bg-slate-50 rounded-xl p-6 space-y-3">
              <p className="font-semibold text-slate-900">AKW Design</p>
              <p className="text-slate-600">Adrian Wojciechowski</p>
              <p className="text-slate-600">Jakob-Mankel-Straße 20</p>
              <p className="text-slate-600">35781 Weilburg</p>
              <div className="pt-3 space-y-2">
                <a href="tel:+4915510904109" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
                  <Phone className="w-4 h-4" />
                  <span>+49 155 10904109</span>
                </a>
                <a href="mailto:akw-design@gmx.de" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
                  <Mail className="w-4 h-4" />
                  <span>akw-design@gmx.de</span>
                </a>
              </div>
            </div>
          </section>

          {/* Data Collection */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Erhebung personenbezogener Daten</h2>
            <p className="text-slate-600 leading-relaxed">
              Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, werden die von Ihnen 
              übermittelten Daten (z.B. Name, E-Mail-Adresse, Nachricht) gespeichert, um Ihre Anfrage 
              zu bearbeiten und eventuelle Anschlussfragen beantworten zu können.
            </p>
          </section>

          {/* Legal Basis */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <FileCheck className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Rechtsgrundlage</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
              (Vertragserfüllung bzw. vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO 
              (berechtigtes Interesse an der Bearbeitung von Anfragen).
            </p>
          </section>

          {/* Storage Duration */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center">
                <Clock className="w-5 h-5 text-slate-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Speicherdauer</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Ihre Daten werden nur so lange gespeichert, wie dies zur Bearbeitung Ihrer Anfrage 
              erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Ablauf der 
              entsprechenden Fristen werden die Daten routinemäßig gelöscht.
            </p>
          </section>

          {/* User Rights */}
          <section className="border-t border-slate-200 pt-10">
            <h2 className="text-xl font-bold text-slate-900 mb-4">Ihre Rechte</h2>
            <p className="text-slate-600 mb-6">
              Sie haben jederzeit das Recht auf:
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="font-semibold text-slate-900 mb-2">Auskunft</h3>
                <p className="text-sm text-slate-600">Informationen über Ihre gespeicherten Daten</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="font-semibold text-slate-900 mb-2">Berichtigung</h3>
                <p className="text-sm text-slate-600">Korrektur unrichtiger Daten</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="font-semibold text-slate-900 mb-2">Löschung</h3>
                <p className="text-sm text-slate-600">Entfernung Ihrer Daten</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="font-semibold text-slate-900 mb-2">Einschränkung</h3>
                <p className="text-sm text-slate-600">Beschränkung der Verarbeitung</p>
              </div>
            </div>
            <p className="text-slate-600 mt-6">
              Um Ihre Rechte auszuüben, kontaktieren Sie uns bitte unter: 
              <a href="mailto:akw-design@gmx.de" className="text-teal-600 hover:text-teal-700 ml-1">
                akw-design@gmx.de
              </a>
            </p>
          </section>

          {/* Cookies */}
          <section className="border-t border-slate-200 pt-10">
            <h2 className="text-xl font-bold text-slate-900 mb-4">Cookies</h2>
            <p className="text-slate-600 leading-relaxed">
              Unsere Website verwendet technisch notwendige Cookies, die für den Betrieb der Website 
              erforderlich sind. Diese Cookies speichern keine personenbezogenen Daten und werden 
              nach dem Schließen des Browsers gelöscht.
            </p>
          </section>

        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline" className="rounded-full px-8">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
